import { render } from "./SireFooter.vue?vue&type=template&id=4fc529b2&scoped=true&ts=true"
import script from "./SireFooter.vue?vue&type=script&lang=ts"
export * from "./SireFooter.vue?vue&type=script&lang=ts"

import "./SireFooter.vue?vue&type=style&index=0&id=4fc529b2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc529b2"]])

export default __exports__